import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PartialsModule } from '../partials/partials.module';
import { CoreModule } from '../../core/core.module';
import { CalendarModule } from './calendar/calendar.module';
import { PatientRangesComponent } from './me/device/patient-ranges/patient-ranges.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatFormioModule } from 'angular-material-formio';
import { MatDialogModule } from '@angular/material/dialog';
import { FollowUpDialogComponent } from './follow-up/follow-up-dialog/follow-up-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NewAttemptDialogComponent } from './follow-up/new-attempt-dialog/new-attempt-dialog.component';
import { FollowUpService } from '../../core/services/follow-up.service';
import { WorkflowModule } from './workflow/workflow.module';
import { CreateWorkflowDialogComponent } from './workflow/create-workflow-dialog/create-workflow-dialog.component';
import { AttemptListComponent } from './follow-up/attempt-list/attempt-list.component';
import { MatSortModule } from '@angular/material/sort';
import { WorkflowHistoryComponent } from './workflow/workflow-history/workflow-history.component';
import { FollowupModule } from './followup/followup.module';

@NgModule({
  declarations: [
    PatientRangesComponent,
    FollowUpDialogComponent,
    NewAttemptDialogComponent,
    AttemptListComponent,
  ],
  exports: [],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    CoreModule,
    PartialsModule,
    CalendarModule,
    FollowupModule,
    PerfectScrollbarModule,
    MatFormioModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    WorkflowModule,
    MatSortModule,
  ],
  providers: [FollowUpService],
  entryComponents: [CreateWorkflowDialogComponent, WorkflowHistoryComponent],
})
export class PagesModule {}
